var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisibilitySensorL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 457,
    height: 374,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1376,
    y: 751,
    width: 457,
    height: 374
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-1376 -751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1824.5 759.5 1604.5 1116.5 1384.5 759.5Z",
    stroke: "#000000",
    strokeWidth: 17.1875,
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#3865B6",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibilitySensorL);
export default __webpack_public_path__ + "static/media/VisibilitySensorL.bbcbd42245b4c9d5405d9ff11bdb2139.svg";
export { ForwardRef as ReactComponent };